<div class="result flex">
    <span>=&nbsp;</span>
    <span class="underline font-bold">{{ result$ | async }}</span>
    <mat-error *ngIf="formulaInvalid$ | async"><fa-icon icon="exclamation-triangle"></fa-icon></mat-error>
</div>
